module.exports = __webpack_public_path__ + "img/img16.9c08b53f.jpg";